import ManageAnnulation from '@/components/comptable/demande-annulation/manage-annulation';
import store_operation from "@/store/mods/caisse/operations"

export default {
    name: 'demande-annulation',
    components: {
        ManageAnnulation
    },
    props: [],
    data() {
        return {
            months: [
                { id: 1, lib: "Janvier" }, { id: 2, lib: "Février" },
                { id: 3, lib: "Mars" }, { id: 4, lib: "Avril" },
                { id: 5, lib: "Mai" }, { id: 6, lib: "Juin" },
                { id: 7, lib: "Juillet" }, { id: 8, lib: "Août" },
                { id: 9, lib: "Septembre" }, { id: 10, lib: "Octobre" },
                { id: 11, lib: "Novembre" }, { id: 12, lib: "Décembre" },
            ],

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            filter_date: "",
            curr_month: "",
            date: new Date(),

            fields: [
                { key: 'ref', label: 'Référence' }, { key: 'demande_le', label: 'Demandée le' },
                { key: 'auteur', label: 'Caissier' }, 'justification', { key: 'statut', label: 'Statut' }, { key: 'action', label: 'Action' }
            ],
            perPage: -1,
            filter: "",
            statut: 'a_valider',
            from: '',
            to: '',
            currentPage: 1,
            current_date_filter: {},
            demande_is_loading: true,
            demande_is_empty: false,

            demandeur_id: 0,
            justification: '',
            annul_operations: [],
            compte_id: 0,
            modal_toggler: 0,
            liste_demandes_annulation: []
        }
    },

    computed: {
        nombreEnAttente() {
            return this.liste_demandes_annulation.filter(item => Number(item.reste_a_valider) > 0).length
        },
        demandesFiltrees() {
            return this.liste_demandes_annulation.filter(item => this.statut === 'tous'
                || (this.statut === 'a_valider' ? Number(item.reste_a_valider) > 0 : Number(item.reste_a_valider) === 0))
        },
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        /**
         * Liste of months of the year [ From january to current month ]
         * @returns 
         */
        monthOfYear() {
            let index;
            let m = []
            for (index = 0; index < this.date.getMonth() + 1; index++) {
                m[index] = this.months[index];
            }
            return m;
        },
    },

    mounted() {
        this.current_date_filter = { month: '', one_date: '', from_date: '', to_date: '' }
        this.getDemandeAnnulation(this.current_date_filter)
    },

    methods: {
        getDemandeAnnulation(data) {
            this.demande_is_loading = true

            store_operation.getListeDemandeAnnulation(data).then((demandes_annulation) => {
                this.liste_demandes_annulation = demandes_annulation
                if (this.liste_demandes_annulation.length == 0) {
                    this.demande_is_empty = true
                } else {
                    this.demande_is_empty = false
                }

                this.demande_is_loading = false
            })
        },

        refreshDemande() {
            this.getDemandeAnnulation(this.current_date_filter)
        },

        filtrerDates() {
            if ((this.from && !this.to) || (!this.from && this.to) || (this.from && this.to && this.from > this.to)) return
            this.current_date_filter = { month: '', one_date: '', from_date: this.from, to_date: this.to }
            this.getDemandeAnnulation(this.current_date_filter)
        },

        filterByDate(date) {
            this.current_date_filter = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
            }
            
            this.filter_date = ""

            this.getDemandeAnnulation(this.current_date_filter)
        },

        viewJustification(justification) {
            this.annul_operations = []
            this.justification = justification
        },

        handleAnnulation(data) {
            this.modal_toggler = (this.modal_toggler == 0)?1:0
            this.annul_operations = data.operations
            this.justification = data.justification
            this.compte_id = data.compte_id
            this.demandeur_id = data.demandeur.id
        }
    }
}


